import { render, staticRenderFns } from "./case-items.vue?vue&type=template&id=0dc7e56a&scoped=true&"
import script from "./case-items.vue?vue&type=script&lang=js&"
export * from "./case-items.vue?vue&type=script&lang=js&"
import style0 from "./case-items.vue?vue&type=style&index=0&id=0dc7e56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc7e56a",
  null
  
)

export default component.exports